<app-pcbread-crumb [data]="'CashDesk'"></app-pcbread-crumb>

<div id="cashdeskParent" class="card p-2 animate__animated animate__backInDown">
  <!-- <input id="focustest" class="barcodScanner" type="text"> -->

  <app-pctable-action
    [data]="action"
    [header]="searchField"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable
    [data]="data"
    [entityField]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<app-pcsetting-modal (parentAction)="parentAction($event)" [fields]="fields">
</app-pcsetting-modal>

<ng-template #credit let-modal>
  <form class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title secondary-font" id="modalTopTitle">
        {{ "credit" | translate }}
      </h5>
      <button
        type="button"
        class="btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <div class="card">
        <div class="row">
          <div class="co-12">
            <span
              class="message-scanner-box"
              [ngClass]="{ 'message-danger': scannerCompleted == false }"
              >{{ scannerLog }}</span
            >
          </div>
        </div>
        <div
          class="row p-2 mb-2 items"
          *ngFor="let item of factorList; let i = index"
        >
          <div class="col-4">
            <label>فاکتور شماره {{ i + 1 }} </label>
          </div>
          <div class="col-5">
            <span> {{ item.totalPrice | number }} تومان</span>
          </div>
          <div class="col-1">+</div>
          <div class="col-2">
            <button
              type="button"
              class="btn btn-icon btn-outline-danger"
              (click)="deleteFactorList(item)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <div class="row final-payment">
          <div class="col-12">
            <input
              id="barcodScanner"
              type="text"
              class="barcodScanner"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="scannedBarcode"
              (keyup.Enter)="addNewItem()"
              (blur)="setFocus()"
            />
            <hr />
          </div>
          <div class="col-5">
            <label> مبلغ پرداختنی</label>
          </div>
          <div class="col-7">
            <label> {{ finalPayment | number }} تومان</label>
          </div>
        </div>
        <app-loading-panel *ngIf="newBarcodLoading"></app-loading-panel>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-success"
        >
        <!-- (click)="confirmPayment(true)" -->
        {{ "Cash" | translate }}
      </button>
      <button type="button" class="btn btn-primary">
        {{ "SendToPos" | translate }}
      </button>
    </div>
  </form>
</ng-template>

<ng-template #credit let-modal>
  <form class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title secondary-font" id="modalTopTitle">
        {{ "FastSale" | translate }}
      </h5>
    </div>
    <div class="modal-body">
      <div class="card">
        <div class="row">
          <div class="co-12">
            <span
              class="message-scanner-box"
              [ngClass]="{ 'message-danger': scannerCompleted == false }"
              >{{ scannerLog }}</span
            >
          </div>
        </div>
        <div
          class="row p-2 mb-2 items"
          *ngFor="let item of factorList; let i = index"
        >
          <div class="col-4">
            <label>فاکتور شماره {{ i + 1 }} </label>
          </div>
          <div class="col-5">
            <span> {{ item.totalPrice | number }} تومان</span>
          </div>
          <div class="col-1">+</div>
          <div class="col-2">
            <button
              type="button"
              class="btn btn-icon btn-outline-danger"
              (click)="deleteFactorList(item)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <div class="row final-payment">
          <div class="col-12">
            <input
              id="barcodScanner"
              type="text"
              class="barcodScanner"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="scannedBarcode"
              (keyup.Enter)="addNewItem()"
              (blur)="setFocus()"
            />
            <hr />
          </div>
          <div class="col-5">
            <label> مبلغ پرداختنی</label>
          </div>
          <div class="col-7">
            <label> {{ finalPayment | number }} تومان</label>
          </div>
        </div>
        <app-loading-panel *ngIf="newBarcodLoading"></app-loading-panel>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-success"
        >
        <!-- (click)="confirmPayment(true)" -->
        {{ "Cash" | translate }}
      </button>
      <button type="button" class="btn btn-primary">
        {{ "SendToPos" | translate }}
      </button>
    </div>
  </form>
</ng-template>

<ng-template #modalContent let-modal>
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">حذف</h6>
    <button
      type="button"
      class="btn-close close-modal-button text-reset"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body mx-0 flex-grow-0">
    <form class="add-new-user pt-0" autofil autocomplete="false">
      <div class="row modal-body-form">
        <div class="col-6 mb-3">
          <h6>آیا از حذف این رکورد مطمئن هستید؟</h6>
        </div>
      </div>

      <app-loading-panel *ngIf="!fields"> </app-loading-panel>
    </form>
  </div>
  <div class="modal-footer border-top p-3">
    <button
      type="submit"
      class="btn btn-primary me-sm-3 me-1 data-submit"
      (click)="submitDelete()"
    >
      {{ "Submit" | translate }}
    </button>
    <button
      type="reset"
      class="btn btn-label-secondary"
      (click)="modal.dismiss('Cross click')"
    >
      {{ "Cancel" | translate }}
    </button>
  </div>
</ng-template>
